import { Box, Flex, Typography } from "@strapi/design-system"
import { ExclamationMarkCircle } from "@strapi/icons"
import { useTranslation } from "react-i18next"

export const PageNotFound = () => {
  const { t } = useTranslation()

  return (
    <Box height="100vh">
      <Flex direction="column" alignItems="center" justifyContent="center" height="100%">
        <ExclamationMarkCircle width="64" height="64" />
        <Box padding={3} />
        <Typography variant="alpha">{t("pageNotFound")}</Typography>
      </Flex>
    </Box>
  )
}
